module.exports = __webpack_public_path__ + "img/classes3.325a0d5c.png";